import { render, staticRenderFns } from "./ProcessItems.vue?vue&type=template&id=62d654ac&"
import script from "./ProcessItems.vue?vue&type=script&lang=js&"
export * from "./ProcessItems.vue?vue&type=script&lang=js&"
import style0 from "./ProcessItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports